import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth";

export const firebaseConfig = {
    apiKey: "AIzaSyDR-RYOoBPUiBVojyWZOyBaq6f_TsfM8Mo",
    authDomain: "pb-chat-bot-ac.firebaseapp.com",
    projectId: "pb-chat-bot-ac",
    storageBucket: "pb-chat-bot-ac.firebasestorage.app",
    messagingSenderId: "542366175550",
    appId: "1:542366175550:web:62ddd2e354be98e2559c6f"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };